import Workspace from '@models/workspace/workspace'
import api from '@/api/Api'
import store from '@state/store'

export const state = {
  workspaces: [],
  recentWorkspaces: [],
  firstLoad: true,
  loading: false
}

export const getters = {
  onLoading (state) {
    return state.firstLoad
  },
  workspaces (state) {
    return state.workspaces
  },
  recentWorkspaces (state) {
    return state.recentWorkspaces
  }
}

export const mutations = {
  SET_WORKSPACE (state, newValue) {
    state.firstLoad = false
    state.workspaces = newValue
  },
  SET_RECENT_WORKSPACE (state, newValue) {
    state.recentWorkspaces = newValue
  },
  UPDATE_STATUS_LOADING (state) {
    state.loading = !state.loading
  }
}
export const actions = {
  onShareWorkspace ({ commit, state, dispatch, rootState }, form) {
    return api.shareWorkspace(form).then((response) => {
      return response
    })
  },
  async fetchWorkspace ({ commit, state, dispatch }, data) {
    if (!state.loading) {
      commit('UPDATE_STATUS_LOADING')
      const res = await api.getWorkspaces(data)

      if (res) {
        const workspaces = res.data.data.map((val, index) => new Workspace(val, index))
        commit('SET_WORKSPACE', workspaces)
        commit('UPDATE_STATUS_LOADING')
        return workspaces
      } else {
        commit('SET_WORKSPACE', [])
      }
    }
  },
  async fetchRecentWorkspace ({commit, state, dispatch}) {
    const { data } = await api.getRecentWorkspace()
    commit('SET_RECENT_WORKSPACE', data.data.map((val, index) => new Workspace(val, index)))
  },
  createNewWorkSpace ({ commit, state, dispatch, rootState }, form) {
    return api.createWorkspace(form).then((response) => {
      dispatch('fetchWorkspace')
      return response
    })
  },
  updateCurrentWorkspace ({ commit, dispatch, state, rootState }, form) {
    return api.updateWorkspace(form).then((response) => {
      dispatch('fetchRecentWorkspace')
      dispatch('fetchWorkspace')
      return response
    })
  },
  deleteCurrentWorkspace ({ commit, state, dispatch, rootState }, id) {
    return api.deleteWorkspace(id).then((response) => {
      dispatch('fetchRecentWorkspace')
      dispatch('fetchWorkspace')
      return response
    })
  },

  async deleteSharedWorkspace ({ commit, dispatch }, payload) {
    await api.removeSharedWorkspace(payload)
    dispatch('fetchRecentWorkspace')
    dispatch('fetchWorkspace')
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/workspace.js